var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgJobs2 = function SvgJobs2(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33309 5.99992V5.26658C7.33309 3.64409 7.33309 2.33325 10.2664 2.33325H11.7331C14.6664 2.33325 14.6664 3.64409 14.6664 5.26658V5.99992M7.33309 20.6666H14.6664C18.3514 20.6666 19.0114 19.1908 19.2039 17.3941L19.8914 10.0608C20.1389 7.82409 19.4973 5.99992 15.5831 5.99992H6.41643C2.50226 5.99992 1.86059 7.82409 2.10809 10.0608L2.79559 17.3941C2.98809 19.1908 3.64809 20.6666 7.33309 20.6666Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.833 13.3516V12.4166C12.833 11.4999 12.833 11.4999 11.9164 11.4999H10.083C9.16637 11.4999 9.16637 11.4999 9.16637 12.4166V13.3608M12.833 13.3516C12.833 14.3508 12.8239 15.1666 10.9997 15.1666C9.1847 15.1666 9.16637 14.3599 9.16637 13.3608M12.833 13.3516C15.3669 13.0361 17.7795 12.0837 19.8455 10.5833M9.16637 13.3608C6.7922 13.0949 4.46387 12.2424 2.40137 10.8308",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJobs2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jobs2.6fa1b1a0.svg";
export { ForwardRef as ReactComponent };